export const SIMULS = [
{
  id: 0,
  name: 'Detroit 1964',
  featured: true,
  image: '/assets/images/John1.png',
  description:'On tour, Bobby Fischer put on a simultaneous display at the Chess-Mate Gallery in Detroit against 51 players, including several masters and numerous experts. He won 47 games, drew two and lost only two. That he would make a showing of this sort was no doubt expected, but the outstanding feature of the exhibition was the extraordinary rapidity of his play, insofar as he is reported to have consumed no more than an average of six minutes per game! (Chess Review, April 1964)\n'+
              'Here are four games from the simul.'
,
  games:[
  {
    id: 0,
    diagrams:{
      0:'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR',
      1:'rnbqkbnr/pppppppp/8/8/4P3/8/PPPP1PPP/RNBQKBNR',
      2:'rnbqkbnr/pppp1ppp/8/4p3/4P3/8/PPPP1PPP/RNBQKBNR',
      3:'rnbqkbnr/pppp1ppp/8/4p3/4PP2/8/PPPP2PP/RNBQKBNR',
      4:'rnbqkbnr/pppp1ppp/8/8/4Pp2/8/PPPP2PP/RNBQKBNR',
      5:'rnbqkbnr/pppp1ppp/8/8/4Pp2/5N2/PPPP2PP/RNBQKB1R',
      6:'rnbqkbnr/ppp2ppp/8/3p4/4Pp2/5N2/PPPP2PP/RNBQKB1R',
      7:'rnbqkbnr/ppp2ppp/8/3P4/5p2/5N2/PPPP2PP/RNBQKB1R',
      8:'rnbqkb1r/ppp2ppp/5n2/3P4/5p2/5N2/PPPP2PP/RNBQKB1R',
      9:'rnbqkb1r/ppp2ppp/5n2/1B1P4/5p2/5N2/PPPP2PP/RNBQK2R',
      10:'rnbqkb1r/pp3ppp/2p2n2/1B1P4/5p2/5N2/PPPP2PP/RNBQK2R',
      11:'rnbqkb1r/pp3ppp/2P2n2/1B6/5p2/5N2/PPPP2PP/RNBQK2R',
      12:'r1bqkb1r/pp3ppp/2n2n2/1B6/5p2/5N2/PPPP2PP/RNBQK2R',
      13:'r1bqkb1r/pp3ppp/2n2n2/1B6/3P1p2/5N2/PPP3PP/RNBQK2R',
      14:'r1bqk2r/pp3ppp/2nb1n2/1B6/3P1p2/5N2/PPP3PP/RNBQK2R',
      15:'r1bqk2r/pp3ppp/2nb1n2/1B6/3P1p2/5N2/PPP3PP/RNBQ1RK1',
      16:'r1bq1rk1/pp3ppp/2nb1n2/1B6/3P1p2/5N2/PPP3PP/RNBQ1RK1',
      17:'r1bq1rk1/pp3ppp/2Bb1n2/8/3P1p2/5N2/PPP3PP/RNBQ1RK1',
      18:'r1bq1rk1/p4ppp/2pb1n2/8/3P1p2/5N2/PPP3PP/RNBQ1RK1',
      19:'r1bq1rk1/p4ppp/2pb1n2/4N3/3P1p2/8/PPP3PP/RNBQ1RK1',
      20:'r1bq1rk1/p4ppp/2p2n2/4b3/3P1p2/8/PPP3PP/RNBQ1RK1',
      21:'r1bq1rk1/p4ppp/2p2n2/4P3/5p2/8/PPP3PP/RNBQ1RK1',
      22:'r1b2rk1/p4ppp/1qp2n2/4P3/5p2/8/PPP3PP/RNBQ1RK1',
      23:'r1b2rk1/p4ppp/1qp2n2/4P3/5p2/8/PPP3PP/RNBQ1R1K',
      24:'r1b2rk1/p4ppp/1qp5/3nP3/5p2/8/PPP3PP/RNBQ1R1K',
      25:'r1b2rk1/p4ppp/1qp5/3nP3/5p2/8/PPP1Q1PP/RNB2R1K',
      26:'r4rk1/p4ppp/bqp5/3nP3/5p2/8/PPP1Q1PP/RNB2R1K',
      27:'r4rk1/p4ppp/bqp5/3nP3/2P2p2/8/PP2Q1PP/RNB2R1K',
      28:'r4rk1/p4ppp/b1p5/3nP3/2Pq1p2/8/PP2Q1PP/RNB2R1K',
      29:'r4rk1/p4ppp/b1p5/3nP3/2Pq1p2/N7/PP2Q1PP/R1B2R1K',
      30:'r3r1k1/p4ppp/b1p5/3nP3/2Pq1p2/N7/PP2Q1PP/R1B2R1K',
      31:'r3r1k1/p4ppp/b1p5/3nP3/2Pq1p2/N7/PP3QPP/R1B2R1K',
      32:'r3r1k1/p4ppp/b1p5/3nP3/2P2p2/N7/PP3qPP/R1B2R1K',
      33:'r3r1k1/p4ppp/b1p5/3nP3/2P2p2/N7/PP3RPP/R1B4K',
      34:'r5k1/p4ppp/b1p5/3nr3/2P2p2/N7/PP3RPP/R1B4K',
      35:'r5k1/p4ppp/b1p5/3nr3/2P2p2/N7/PP1B1RPP/R6K',
      36:'r5k1/p4ppp/bnp5/4r3/2P2p2/N7/PP1B1RPP/R6K',
      37:'r5k1/p4ppp/bnp5/4r3/2P2B2/N7/PP3RPP/R6K',
      38:'r5k1/p4ppp/bnp5/8/2P1rB2/N7/PP3RPP/R6K',
      39:'r5k1/p4ppp/bnp5/8/2P1rB2/NP6/P4RPP/R6K',
      40:'r5k1/pb3ppp/1np5/8/2P1rB2/NP6/P4RPP/R6K',
      41:'r5k1/pb3ppp/1np5/8/2P1rB2/NP6/P4RPP/3R3K',
      42:'r5k1/1b3ppp/1np5/p7/2P1rB2/NP6/P4RPP/3R3K',
      43:'r5k1/1b3ppp/1np5/p7/2P1rB2/NP5P/P4RP1/3R3K',
      44:'r5k1/1b2rppp/1np5/p7/2P2B2/NP5P/P4RP1/3R3K',
      45:'r5k1/1b2rppp/1np5/p7/2P2B2/NP5P/P2R2P1/3R3K',
      46:'r5k1/1b2r1pp/1np2p2/p7/2P2B2/NP5P/P2R2P1/3R3K',
      47:'r5k1/1b2r1pp/1npB1p2/p7/2P5/NP5P/P2R2P1/3R3K',
      48:'r5k1/1b1r2pp/1npB1p2/p7/2P5/NP5P/P2R2P1/3R3K',
      49:'r5k1/1b1r2pp/1np2p2/p1B5/2P5/NP5P/P2R2P1/3R3K',
      50:'3r2k1/1b1r2pp/1np2p2/p1B5/2P5/NP5P/P2R2P1/3R3K',
      51:'3r2k1/1b1R2pp/1np2p2/p1B5/2P5/NP5P/P5P1/3R3K',
      52:'6k1/1b1r2pp/1np2p2/p1B5/2P5/NP5P/P5P1/3R3K',
      53:'6k1/1b1R2pp/1np2p2/p1B5/2P5/NP5P/P5P1/7K',
      54:'6k1/1b1n2pp/2p2p2/p1B5/2P5/NP5P/P5P1/7K',
      55:'6k1/1b1n2pp/2pB1p2/p7/2P5/NP5P/P5P1/7K',
      56:'6k1/1b4pp/2pB1p2/p3n3/2P5/NP5P/P5P1/7K',
      57:'6k1/1bB3pp/2p2p2/p3n3/2P5/NP5P/P5P1/7K',
      58:'6k1/1bB3pp/2p2p2/p7/2P5/NP1n3P/P5P1/7K',
      59:'6k1/1b4pp/2p2p2/B7/2P5/NP1n3P/P5P1/7K',
      60:'6k1/1b4pp/2p2p2/B7/2P5/NP5P/P5P1/2n4K',
      61:'6k1/1b4pp/2p2p2/8/2P5/NP5P/P2B2P1/2n4K',
      62:'6k1/1b4pp/2p2p2/8/2P5/NP5P/n2B2P1/7K',
      63:'6k1/1b4pp/2p2p2/8/2P5/NP5P/n2B2P1/6K1',
      64:'8/1b3kpp/2p2p2/8/2P5/NP5P/n2B2P1/6K1',
      65:'8/1b3kpp/2p2p2/8/2P5/NP5P/n2B1KP1/8',
      66:'8/1b4pp/2p1kp2/8/2P5/NP5P/n2B1KP1/8',
      67:'8/1b4pp/2p1kp2/8/1PP5/N6P/n2B1KP1/8',
      68:'8/1b4pp/2pk1p2/8/1PP5/N6P/n2B1KP1/8',
      69:'8/1b4pp/2pk1p2/8/1PP5/N5PP/n2B1K2/8',
      70:'2b5/6pp/2pk1p2/8/1PP5/N5PP/n2B1K2/8',
      71:'2b5/6pp/2pk1p2/8/1PP4P/N5P1/n2B1K2/8',
      72:'8/6pp/2pk1p2/5b2/1PP4P/N5P1/n2B1K2/8',
      73:'8/6pp/2pk1p2/5b2/1PP4P/N3K1P1/n2B4/8',
      74:'8/6pp/2p2p2/4kb2/1PP4P/N3K1P1/n2B4/8',
      75:'8/6pp/2p2p2/1P2kb2/2P4P/N3K1P1/n2B4/8',
      76:'8/6pp/5p2/1p2kb2/2P4P/N3K1P1/n2B4/8',
      77:'8/6pp/5p2/1N2kb2/2P4P/4K1P1/n2B4/8',
      78:'8/6pp/4bp2/1N2k3/2P4P/4K1P1/n2B4/8',
      79:'8/6pp/4bp2/1NP1k3/7P/4K1P1/n2B4/8',
      80:'8/3b2pp/5p2/1NP1k3/7P/4K1P1/n2B4/8',
      81:'8/3b2pp/5p2/2P1k3/3N3P/4K1P1/n2B4/8',
      82:'8/3b2pp/5p2/2Pk4/3N3P/4K1P1/n2B4/8',
      83:'8/3b2pp/2P2p2/3k4/3N3P/4K1P1/n2B4/8',
      84:'2b5/6pp/2P2p2/3k4/3N3P/4K1P1/n2B4/8',
      85:'2b5/2P3pp/5p2/3k4/3N3P/4K1P1/n2B4/8',
      86:'2b5/2P3pp/5p2/2k5/3N3P/4K1P1/n2B4/8',
      87:'2b5/2P3pp/5p2/2k5/7P/4K1P1/n2BN3/8',
      88:'2b5/2P3pp/1k3p2/8/7P/4K1P1/n2BN3/8',
      89:'2b5/2P3pp/1k3p2/8/5N1P/4K1P1/n2B4/8',
      90:'2b5/2k3pp/5p2/8/5N1P/4K1P1/n2B4/8',
      91:'2b5/2k3pp/5p2/7N/7P/4K1P1/n2B4/8',
      92:'8/2k3pp/5p2/7N/6bP/4K1P1/n2B4/8',
      93:'8/2k3Np/5p2/8/6bP/4K1P1/n2B4/8',
      94:'3k4/6Np/5p2/8/6bP/4K1P1/n2B4/8',
      95:'3k4/6Np/5p2/8/5KbP/6P1/n2B4/8',
      96:'3k4/3b2Np/5p2/8/5K1P/6P1/n2B4/8',
      97:'3k4/3b3p/5p2/5N2/5K1P/6P1/n2B4/8',
      98:'4k3/3b3p/5p2/5N2/5K1P/6P1/n2B4/8',
      99:'4k3/3b3p/5p2/8/3N1K1P/6P1/n2B4/8',
      100:'8/3b1k1p/5p2/8/3N1K1P/6P1/n2B4/8',
      101:'8/3b1k1p/5p2/8/3NK2P/6P1/n2B4/8',
      102:'8/3b3p/5pk1/8/3NK2P/6P1/n2B4/8',
      103:'8/3b3p/5pk1/3K4/3N3P/6P1/n2B4/8',
      104:'4b3/7p/5pk1/3K4/3N3P/6P1/n2B4/8',
      105:'4b3/7p/4Kpk1/8/3N3P/6P1/n2B4/8',
      106:'8/5b1p/4Kpk1/8/3N3P/6P1/n2B4/8',
      107:'8/4Kb1p/5pk1/8/3N3P/6P1/n2B4/8',
      108:'8/4K2p/5pk1/3b4/3N3P/6P1/n2B4/8',
      109:'8/4K2p/4Npk1/3b4/7P/6P1/n2B4/8',
      110:'8/4K2p/4Npk1/8/2b4P/6P1/n2B4/8',
      111:'5N2/4K2p/5pk1/8/2b4P/6P1/n2B4/8',
      112:'5N2/4K1kp/5p2/8/2b4P/6P1/n2B4/8',
      113:'5N2/4K1kp/5p2/7P/2b5/6P1/n2B4/8',
      114:'5N2/4K1kp/5p2/7P/8/1b4P1/n2B4/8',
      115:'5N2/4K1kp/5p1P/8/8/1b4P1/n2B4/8',
      116:'5Nk1/4K2p/5p1P/8/8/1b4P1/n2B4/8',
      117:'6k1/3NK2p/5p1P/8/8/1b4P1/n2B4/8',
      118:'6k1/3NK2p/7P/5p2/8/1b4P1/n2B4/8',
      119:'6k1/4K2p/5N1P/5p2/8/1b4P1/n2B4/8',
      120:'7k/4K2p/5N1P/5p2/8/1b4P1/n2B4/8',
      121:'5K1k/7p/5N1P/5p2/8/1b4P1/n2B4/8',
      122:'5K1k/7p/4bN1P/5p2/8/6P1/n2B4/8',
      123:'5K1k/7p/4b2P/3N1p2/8/6P1/n2B4/8'
      },
      comments:{
      0:'Bobby Fischer - Jack Witeczek.',1:'1.e4', 2:'1...e5 Jack Witeczek was born in Lodz, Poland, and came to the U.S. in 1958. He was the 1960 Ohio Champion, 1964 Michigan Champion and tied for 7th-11th in the 1961 U.S. Open in San Francisco.', 3:'2.f4', 4:'2...exf4', 5:'3.Nf3', 6:'3...d5', 7:'4.exd5', 8:'4...Nf6', 9:'5.Bb5+', 10:'5...c6 5...Nbd7 is not seen as often as the text but is playable.', 11:'6.dxc6',
      12:'5...Nxc6', 13:'7.d4', 14:'7...Bd6', 15:'8.O-O', 16:'8...O-O', 17:'9.Bxc6?! A rare continuation and apparently not that strong. 9.c4, 9.Nc3 and 9.Nbd2 are all more popular.', 18:'9...bxc6', 19:'10.Ne5', 20:'10...Bxe5 10...g5 is another way to handle the position - 11.Nxc6?? Qb6, but Witeczek\'s choice is also good and simpler. ', 21:'11.dxe5',
      22:'11...Qb6+', 23:'12.Kh1', 24:'12...Nd5 12...Ng4 13.Qe1 Ne3 14.Bxe3 fxe3 would have given Black a small advantage. For example: 15.Nc3 Re8 16.Qg3 Qxb2 17.Qxe3 Ba6 18.Rfe1 Rad8 19.Qxa7 Qxc3 20.Qxa6 Rxe5.', 25:'13.Qe2', 26:'13...Ba6', 27:'14.c4', 28:'14...Qd4', 29:'15.Na3', 30:'15...Rfe8', 31:'16.Qf2',
      32:'15...Qxf2', 33:'17.Rxf2', 34:'17...Rxe5 17...Nb4! would have been stronger.', 35:'18.Bd2', 36:'18...Nb6 Possible is 18...Ne3 19.Rxf4 Rd8.', 37:'19.Bxf4 Bobby has equalized. Now it\'s time to outplay his opponent step by step. ', 38:'19...Re4', 39:'20.b3', 40:'20...Bb7', 41:'21.Rd1',
      42:'21...a5 Black wants to get rid of a weakness by advancing with ...a4 but there isn\'t time for this. 21...Rae8 was better with equal chances. ', 43:'22.h3', 44:'22...Re7 22...a4 23.Bc7! axb3 24.Bxb6 wins a piece due to the weak back rank.', 45:'23.Rfd2', 46:'23...f6', 47:'24.Bd6 Bringing the knight back into the game with 24.Nc2 also made sense.', 48:'24...Rd7', 49:'25.Bc5 25.Nc2 kept an edge.', 50:'25...Rad8', 51:'26.Rxd7',
      52:'26...Rxd7', 53:'27.Rxd7 27.Re1 was objectively stronger.', 54:'27...Nxd7', 55:'28.Bd6 White has two advantages in this position, neither relating to the position which is dead even. First he is Fischer! Second by this time many of the players have already lost and Witeczek has less time to think as Bobby is coming around faster and faster.', 56:'28...Ne5? 28...Kf7 was correct with the point that if White insists on winning material with 29.Bc7 a4 30.bxa4 Black\'s excellent king position fully compensates for the material deficit. For example 30...Ke6 31.Kg1 Kf5 32.Kf2 Ke4 33.Ke2 Kd4 34.Kd2 Ba6 Black should not have any problems drawing after playing the move he chose but the position will require more care. ', 57:'29.Bc7', 58:'29...Nd3', 59:'30.Bxa5', 60:'30...Nc1',
      61:'31.Bd2', 62:'31...Nxa2 Black has managed to maintain material equality but at the cost of getting his knight semi-trapped. He should still be fine but needs to be alert.', 63:'32.Kg1', 64:'32...Kf7', 65:'33.Kf2', 66:'33...Ke6', 67:'34.b4', 68:'34...Kd6', 69:'35.g3', 70:'35...Bc8',
      71:'36.h4', 72:'36...Bf5', 73:'37.Ke3', 74:'37...Ke5', 75:'38.b5', 76:'38...cxb5', 77:'39.Nxb5', 78:'39...Be6', 79:'40.c5', 80:'40...Bd7',
      81:'41.Nd4', 82:'41...Kd5', 83:'42.c6!? Tricky play by Bobby. The position is a draw but he sets practical problems for his opponent.', 84:'42...Bc8? The text should not lose, but Black had a clear cut draw with 42...Bxc6 43.Nxc6 (43.Nf5 g6 44.Ne7+ Kd6 45.Nxc6 Kxc6 46.Kd4 Kd6 47.Kc4 Ke5 leads to similar play to the main variation.) 43...Kxc6 44.Kd4 Kd6 45.Kc4 Ke5. The knight is now lost, but the king saves the day after 46.Kb3 Ke4 47.Kxa2 Kf3 48.Be1 Ke2 49.Ba5 Kf3 50.Bc7 h5 51.Kb2 g5.', 85:'43.c7', 86:'43...Kc5 43...Kd6! 44.Ba5 (or 44.Kd3 Kxc7 45.Kc2 Kd6 46.Kb2 Kd5 47.Nb3 Ke4 48.Kxa2 Kf3) 44...Nc1 45.Kd2 Kd5 46.Bb6 Na2 and the knight is escaping.', 87:'44.Ne2', 88:'44...Kb6', 89:'45.Nf4', 90:'45...Kxc7',
      91:'46.Nh5', 92:'46...Bg4', 93:'47.Nxg7', 94:'47...Kd8', 95:'48.Kf4', 96:'48...Bd7', 97:'49.Nf5', 98:'49...Ke8', 99:'50.Nd4', 100:'50...Kf7',
      101:'51.Ke4', 102:'51...Kg6', 103:'52.Kd5', 104:'52...Be8', 105:'53.Ke6', 106:'53...Bf7+ 53...Kh5 54.Kxf6 (54.Kf5 Bg6+ 55.Kf4 Bb1) 54...Kg4 55.Bf4 Nc3 was a chance to free the knight.', 107:'54.Ke7', 108:'54...Bd5?! This is an unfortunate square for the bishop. 54...Bc4 had to be played with no clear path to victory for White. That said with the knight on a2 the position will never be pleasant for Black.', 109:'55.Ne6 55.g4! h5 (or 55...h6 56.h5+ Kg7 57.Nf5+ Kh7 58.Kxf6) 56.Ne2! wins. ', 110:'55...Bc4 55...Bf3 (Black must stop h4–h5) 56.Nf8+ Kg7 57.Nd7 f5 58.Ke6 h5, and while White has chances there is no clear win in sight. Note how advancing the pawn to h5 avoids the suffocation of the king that occurs in the game.',
      111:'56.Nf8+ 56.g4!', 112:'56...Kg7 No better is as after 56...Kf5 57.Nxh7 Kg4 58.Nxf6+ Kxg3 59.h5 Bd3 60.h6 Bb1 61.Kf7 Bd3 62.Kg7 Black is helpless to prevent White\'s knight coming to g6. 62...Bb1 63.Nh5+ Kg4 64.Nf4 Nc3 65.Ng6 Ne4 66.h7.', 113:'57.h5', 114:'57...Bb3 Or 57...h6 58.Ne6+ Kh7 59.Nf4 (59.Kxf6? Be2) 59...B3 60.g4 Bc4 61.Kxf6.', 115:'58.h6+', 116:'58...Kg8', 117:'59.Nd7', 118:'59...f5', 119:'60.Nf6+', 120:'60...Kh8',
      121:'61.Kf8', 122:'61...Be6', 123:'62.Nd5 1-0 There is no defense to Bf4 and Be5 mate!'
    }
  },
  {
    id: 1,
    diagrams:{
0:'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR',
1:'rnbqkbnr/pppppppp/8/8/4P3/8/PPPP1PPP/RNBQKBNR',
2:'rnbqkbnr/pp1ppppp/2p5/8/4P3/8/PPPP1PPP/RNBQKBNR',
3:'rnbqkbnr/pp1ppppp/2p5/8/4P3/3P4/PPP2PPP/RNBQKBNR',
4:'rnbqkbnr/pp2pppp/2p5/3p4/4P3/3P4/PPP2PPP/RNBQKBNR',
5:'rnbqkbnr/pp2pppp/2p5/3p4/4P3/3P4/PPPN1PPP/R1BQKBNR',
6:'rnbqkbnr/pp3ppp/2p5/3pp3/4P3/3P4/PPPN1PPP/R1BQKBNR',
7:'rnbqkbnr/pp3ppp/2p5/3pp3/4P3/3P1N2/PPPN1PPP/R1BQKB1R',
8:'r1bqkbnr/pp1n1ppp/2p5/3pp3/4P3/3P1N2/PPPN1PPP/R1BQKB1R',
9:'r1bqkbnr/pp1n1ppp/2p5/3pp3/4P3/3P1NP1/PPPN1P1P/R1BQKB1R',
10:'r1bqkb1r/pp1n1ppp/2p2n2/3pp3/4P3/3P1NP1/PPPN1P1P/R1BQKB1R',
11:'r1bqkb1r/pp1n1ppp/2p2n2/3pp3/4P3/3P1NP1/PPPN1PBP/R1BQK2R',
12:'r1bqkb1r/pp1n1p1p/2p2np1/3pp3/4P3/3P1NP1/PPPN1PBP/R1BQK2R',
13:'r1bqkb1r/pp1n1p1p/2p2np1/3pp3/4P3/3P1NP1/PPPN1PBP/R1BQ1RK1',
14:'r1bqkb1r/pp1n1p1p/2p2np1/4p3/4p3/3P1NP1/PPPN1PBP/R1BQ1RK1',
15:'r1bqkb1r/pp1n1p1p/2p2np1/4p3/4P3/5NP1/PPPN1PBP/R1BQ1RK1',
16:'r1bqk2r/pp1n1pbp/2p2np1/4p3/4P3/5NP1/PPPN1PBP/R1BQ1RK1',
17:'r1bqk2r/pp1n1pbp/2p2np1/4p3/4P3/5NP1/PPPNQPBP/R1B2RK1',
18:'r1bq1rk1/pp1n1pbp/2p2np1/4p3/4P3/5NP1/PPPNQPBP/R1B2RK1',
19:'r1bq1rk1/pp1n1pbp/2p2np1/4p3/4P3/1P3NP1/P1PNQPBP/R1B2RK1',
20:'r1b2rk1/ppqn1pbp/2p2np1/4p3/4P3/1P3NP1/P1PNQPBP/R1B2RK1',
21:'r1b2rk1/ppqn1pbp/2p2np1/4p3/4P3/BP3NP1/P1PNQPBP/R4RK1',
22:'r1b1r1k1/ppqn1pbp/2p2np1/4p3/4P3/BP3NP1/P1PNQPBP/R4RK1',
23:'r1b1r1k1/ppqn1pbp/2p2np1/4p3/2N1P3/BP3NP1/P1P1QPBP/R4RK1',
24:'r1b1r1k1/ppqn1pbp/5np1/2p1p3/2N1P3/BP3NP1/P1P1QPBP/R4RK1',
25:'r1b1r1k1/ppqn1pbp/5np1/2p1p3/2N1P3/BP3NP1/P1P1QPBP/R2R2K1',
26:'r1b1rbk1/ppqn1p1p/5np1/2p1p3/2N1P3/BP3NP1/P1P1QPBP/R2R2K1',
27:'r1b1rbk1/ppqn1p1p/5np1/2p1p3/2N1P3/BP4P1/P1PNQPBP/R2R2K1',
28:'1rb1rbk1/ppqn1p1p/5np1/2p1p3/2N1P3/BP4P1/P1PNQPBP/R2R2K1',
29:'1rb1rbk1/ppqn1p1p/5np1/2p1p3/4P3/BP2N1P1/P1PNQPBP/R2R2K1',
30:'1rb1rbk1/ppq2p1p/1n3np1/2p1p3/4P3/BP2N1P1/P1PNQPBP/R2R2K1',
31:'1rb1rbk1/ppq2p1p/1n3np1/2p1p3/2P1P3/BP2N1P1/P2NQPBP/R2R2K1',
32:'1r2rbk1/ppqb1p1p/1n3np1/2p1p3/2P1P3/BP2N1P1/P2NQPBP/R2R2K1',
33:'1r2rbk1/ppqb1p1p/1n3np1/2p1p3/2P1P3/BP2N1P1/P3QPBP/RN1R2K1',
34:'3rrbk1/ppqb1p1p/1n3np1/2p1p3/2P1P3/BP2N1P1/P3QPBP/RN1R2K1',
35:'3rrbk1/ppqb1p1p/1n3np1/2p1p3/2P1P3/BPN1N1P1/P3QPBP/R2R2K1',
36:'3rrbk1/1pqb1p1p/pn3np1/2p1p3/2P1P3/BPN1N1P1/P3QPBP/R2R2K1',
37:'3rrbk1/1pqb1p1p/pn3np1/2p1p3/2P1P3/BPN1N1P1/P3QPBP/2RR2K1',
38:'2brrbk1/1pq2p1p/pn3np1/2p1p3/2P1P3/BPN1N1P1/P3QPBP/2RR2K1',
39:'2brrbk1/1pq2p1p/pn3np1/2pNp3/2P1P3/BP2N1P1/P3QPBP/2RR2K1',
40:'2brrbk1/1pq2p1p/p4np1/2pnp3/2P1P3/BP2N1P1/P3QPBP/2RR2K1',
41:'2brrbk1/1pq2p1p/p4np1/2pPp3/4P3/BP2N1P1/P3QPBP/2RR2K1',
42:'2brrbk1/2q2p1p/p4np1/1ppPp3/4P3/BP2N1P1/P3QPBP/2RR2K1',
43:'2brrbk1/2q2p1p/p4np1/1pBPp3/4P3/1P2N1P1/P3QPBP/2RR2K1',
44:'1qbrrbk1/5p1p/p4np1/1pBPp3/4P3/1P2N1P1/P3QPBP/2RR2K1',
45:'1qbrrBk1/5p1p/p4np1/1p1Pp3/4P3/1P2N1P1/P3QPBP/2RR2K1',
46:'1qbr1rk1/5p1p/p4np1/1p1Pp3/4P3/1P2N1P1/P3QPBP/2RR2K1',
47:'1qbr1rk1/5p1p/p1R2np1/1p1Pp3/4P3/1P2N1P1/P3QPBP/3R2K1',
48:'1qbrnrk1/5p1p/p1R3p1/1p1Pp3/4P3/1P2N1P1/P3QPBP/3R2K1',
49:'1qbrnrk1/5p1p/p1R3p1/1p1Pp3/4P3/1P2N1P1/P3QPBP/2R3K1',
50:'1qbr1rk1/5p1p/p1Rn2p1/1p1Pp3/4P3/1P2N1P1/P3QPBP/2R3K1',
51:'1qbr1rk1/5p1p/p1Rn2p1/1p1Pp3/4P3/1P2N1P1/P2Q1PBP/2R3K1',
52:'1qbr1r2/5pkp/p1Rn2p1/1p1Pp3/4P3/1P2N1P1/P2Q1PBP/2R3K1',
53:'1qbr1r2/5pkp/p1Rn2p1/1p1Pp3/4PP2/1P2N1P1/P2Q2BP/2R3K1',
54:'1qbr1r2/6kp/p1Rn1pp1/1p1Pp3/4PP2/1P2N1P1/P2Q2BP/2R3K1',
55:'1qbr1r2/6kp/p1Rn1pp1/1p1Pp3/4PP2/1P2N1P1/PQ4BP/2R3K1',
56:'1qbr1r2/6kp/p1Rn1pp1/1p1P4/4Pp2/1P2N1P1/PQ4BP/2R3K1',
57:'1qbr1r2/6kp/p1Rn1pp1/1p1P4/4PP2/1P2N3/PQ4BP/2R3K1',
58:'1qbr1rk1/7p/p1Rn1pp1/1p1P4/4PP2/1P2N3/PQ4BP/2R3K1',
59:'1qbr1rk1/7p/p1Rn1pp1/1p1PP3/5P2/1P2N3/PQ4BP/2R3K1',
60:'1qbr1rk1/7p/p1Rn2p1/1p1Pp3/5P2/1P2N3/PQ4BP/2R3K1',
61:'1qbr1rk1/7p/p1Rn2p1/1p1PP3/8/1P2N3/PQ4BP/2R3K1',
62:'1qbr1rk1/7p/p1R3p1/1p1PPn2/8/1P2N3/PQ4BP/2R3K1',
63:'1qbr1rk1/7p/p1R3p1/1p1PPn2/6N1/1P6/PQ4BP/2R3K1',
64:'1qbr1r1k/7p/p1R3p1/1p1PPn2/6N1/1P6/PQ4BP/2R3K1',
65:'1qbr1r1k/7p/p1R1P1p1/1p1P1n2/6N1/1P6/PQ4BP/2R3K1',
66:'1qbr1r1k/6np/p1R1P1p1/1p1P4/6N1/1P6/PQ4BP/2R3K1',
67:'1qbr1r1k/2R3np/p3P1p1/1p1P4/6N1/1P6/PQ4BP/2R3K1',
},
comments:{
0:'Bobby Fischer - Jeff Richburg.',
1:'1.e4', 2:'1...c6', 3:'2.d3', 4:'2...d5', 5:'3.Nd2', 6:'3...e5', 7:'4.Ngf3', 8:'4...Nd7', 9:'5.g3', 10:'5...Ngf6', 11:'6.Bg2', 12:'6...g6',
13:'7.O-O', 14:'7...dxe4', 15:'8.dxe4', 16:'8...Bg7', 17:'9.Qe2', 18:'9...O-O', 19:'10.b3', 20:'10...Qc7', 21:'11.Ba3', 22:'11...Re8',
23:'12.Nc4', 24:'12...c5?! This weakens the d5-square. See White’s 17th move.', 25:'13.Rfd1', 26:'13...Bf8', 27:'14.Nfd2', 28:'14...Rb8', 29:'15.Ne3', 30:'15...Nb6', 31:'16.c4', 32:'16...Bd7',
33:'17.Nb1! The knight is heading for d5. Fischer’s knowledge of the structure e4 and c3 versus ...e5 and ...c5 is unparalleled. During his career he won many games with it both as White (usually via the Ruy) and Black (King’s Indian). For one of the last examples of Bobby’s knack for finding the right knight maneuver to crack the enemy position see the first game of his 1992 match with Spassky where Ng3-f1-d2-b1, intending Na3, did the trick.', 34:'17...Rbd8', 35:'18.Nc3', 36:'18...a6', 37:'19.Rac1', 38:'19...Bc8', 39:'20.Ncd5', 40:'20...Nbxd5', 41:'21.cxd5',
42:'21...b5', 43:'22.Bxc5!', 44:'22...Qb8 If 22...Bxc5 White has 23.b4 recovering the piece with much the better game.', 45:'23.Bxf8', 46:'23...Rxf8', 47:'24.Rc6', 48:'24...Ne8', 49:'25.Rdc1', 50:'25...Nd6', 51:'26.Qd2',
52:'25...Kg7', 53:'27.f4', 54:'27...f6', 55:'28.Qb2', 56:'28...exf4', 57:'29.gxf4', 58:'29...Kg8', 59:'30.e5', 60:'30...fxe5', 61:'31.fxe5',
62:'31...Nf5', 63:'32.Ng4', 64:'32...Kh8', 65:'33.e6+', 66:'33...Ng7', 67:'34.Rc7',
}
},
{
  id:2,
  diagrams:{
0:'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR',
1:'rnbqkbnr/pppppppp/8/8/4P3/8/PPPP1PPP/RNBQKBNR',
2:'rnbqkbnr/pppp1ppp/4p3/8/4P3/8/PPPP1PPP/RNBQKBNR',
3:'rnbqkbnr/pppp1ppp/4p3/8/3PP3/8/PPP2PPP/RNBQKBNR',
4:'rnbqkbnr/ppp2ppp/4p3/3p4/3PP3/8/PPP2PPP/RNBQKBNR',
5:'rnbqkbnr/ppp2ppp/4p3/3p4/3PP3/2N5/PPP2PPP/R1BQKBNR',
6:'rnbqk1nr/ppp2ppp/4p3/3p4/1b1PP3/2N5/PPP2PPP/R1BQKBNR',
7:'rnbqk1nr/ppp2ppp/4p3/3pP3/1b1P4/2N5/PPP2PPP/R1BQKBNR',
8:'rnbqk2r/ppp1nppp/4p3/3pP3/1b1P4/2N5/PPP2PPP/R1BQKBNR',
9:'rnbqk2r/ppp1nppp/4p3/3pP3/1b1P4/P1N5/1PP2PPP/R1BQKBNR',
10:'rnbqk2r/ppp1nppp/4p3/3pP3/3P4/P1b5/1PP2PPP/R1BQKBNR',
11:'rnbqk2r/ppp1nppp/4p3/3pP3/3P4/P1P5/2P2PPP/R1BQKBNR',
12:'rnbqk2r/pp2nppp/4p3/2ppP3/3P4/P1P5/2P2PPP/R1BQKBNR',
13:'rnbqk2r/pp2nppp/4p3/2ppP3/P2P4/2P5/2P2PPP/R1BQKBNR',
14:'rnb1k2r/pp2nppp/4p3/q1ppP3/P2P4/2P5/2P2PPP/R1BQKBNR',
15:'rnb1k2r/pp2nppp/4p3/q1ppP3/P2P4/2P5/2PB1PPP/R2QKBNR',
16:'r1b1k2r/pp2nppp/2n1p3/q1ppP3/P2P4/2P5/2PB1PPP/R2QKBNR',
17:'r1b1k2r/pp2nppp/2n1p3/q1ppP3/P2P4/2P2N2/2PB1PPP/R2QKB1R',
18:'r1b1k2r/pp2nppp/2n1p3/q2pP3/P1pP4/2P2N2/2PB1PPP/R2QKB1R',
19:'r1b1k2r/pp2nppp/2n1p3/q2pP1N1/P1pP4/2P5/2PB1PPP/R2QKB1R',
20:'r1b1k2r/pp2npp1/2n1p2p/q2pP1N1/P1pP4/2P5/2PB1PPP/R2QKB1R',
21:'r1b1k2r/pp2npp1/2n1p2p/q2pP3/P1pP4/2P4N/2PB1PPP/R2QKB1R',
22:'r3k2r/pp1bnpp1/2n1p2p/q2pP3/P1pP4/2P4N/2PB1PPP/R2QKB1R',
23:'r3k2r/pp1bnpp1/2n1p2p/q2pP3/P1pP1N2/2P5/2PB1PPP/R2QKB1R',
24:'2kr3r/pp1bnpp1/2n1p2p/q2pP3/P1pP1N2/2P5/2PB1PPP/R2QKB1R',
25:'2kr3r/pp1bnpp1/2n1p2p/q2pP3/P1pP1N2/2P5/2PBBPPP/R2QK2R',
26:'2kr3r/pp1bn1p1/2n1pp1p/q2pP3/P1pP1N2/2P5/2PBBPPP/R2QK2R',
27:'2kr3r/pp1bn1p1/2n1pP1p/q2p4/P1pP1N2/2P5/2PBBPPP/R2QK2R',
28:'2kr3r/pp1bn3/2n1pp1p/q2p4/P1pP1N2/2P5/2PBBPPP/R2QK2R',
29:'2kr3r/pp1bn3/2n1pp1p/q2p4/P1pP1N2/2P5/2PBBPPP/R2Q1RK1',
30:'2kr3r/pp1bn3/2n2p1p/q2pp3/P1pP1N2/2P5/2PBBPPP/R2Q1RK1',
31:'2kr3r/pp1bn3/2n2p1p/q2pp2N/P1pP4/2P5/2PBBPPP/R2Q1RK1',
32:'2k2r1r/pp1bn3/2n2p1p/q2pp2N/P1pP4/2P5/2PBBPPP/R2Q1RK1',
33:'2k2r1r/pp1bn3/2n2p1p/q2pp2N/P1pP4/2P5/2PBBPPP/R2Q1R1K',
34:'1k3r1r/pp1bn3/2n2p1p/q2pp2N/P1pP4/2P5/2PBBPPP/R2Q1R1K',
35:'1k3r1r/pp1bn3/2n2p1p/q2pp2N/P1pP4/2P5/2PBBPPP/1R1Q1R1K',
36:'k4r1r/pp1bn3/2n2p1p/q2pp2N/P1pP4/2P5/2PBBPPP/1R1Q1R1K',
37:'k4r1r/pp1bn3/2n2p1p/q2pp2N/P1pP4/2P5/2PBBPPP/1RQ2R1K',
38:'k4r1r/ppqbn3/2n2p1p/3pp2N/P1pP4/2P5/2PBBPPP/1RQ2R1K',
39:'k4r1r/ppqbn3/2n2p1B/3pp2N/P1pP4/2P5/2P1BPPP/1RQ2R1K',
40:'k6r/ppqbnr2/2n2p1B/3pp2N/P1pP4/2P5/2P1BPPP/1RQ2R1K',
41:'k6r/ppqbnr2/2n2p1B/3pP2N/P1p5/2P5/2P1BPPP/1RQ2R1K',
42:'k6r/ppqbn2r/2n2p1B/3pP2N/P1p5/2P5/2P1BPPP/1RQ2R1K',
43:'k6r/ppqbn1Br/2n2p2/3pP2N/P1p5/2P5/2P1BPPP/1RQ2R1K',
44:'k6r/ppqbn1B1/2n2p2/3pP2r/P1p5/2P5/2P1BPPP/1RQ2R1K',
45:'k6r/ppqbn1B1/2n2p2/3pP2B/P1p5/2P5/2P2PPP/1RQ2R1K',
46:'k7/ppqbn1B1/2n2p2/3pP2r/P1p5/2P5/2P2PPP/1RQ2R1K',
47:'k7/ppqbn3/2n2B2/3pP2r/P1p5/2P5/2P2PPP/1RQ2R1K',
48:'k7/ppqbn3/5B2/3pn2r/P1p5/2P5/2P2PPP/1RQ2R1K',
49:'k7/ppqbn3/5B2/3pn2r/P1p2Q2/2P5/2P2PPP/1R3R1K',
50:'k7/ppqb4/5Bn1/3pn2r/P1p2Q2/2P5/2P2PPP/1R3R1K',
51:'k7/ppqb4/6n1/3pB2r/P1p2Q2/2P5/2P2PPP/1R3R1K',
52:'k7/pp1b4/6n1/3pq2r/P1p2Q2/2P5/2P2PPP/1R3R1K',
53:'k7/pp1b4/6n1/3pQ2r/P1p5/2P5/2P2PPP/1R3R1K',
54:'k7/pp1b4/8/3pn2r/P1p5/2P5/2P2PPP/1R3R1K',
55:'k7/pp1b4/8/P2pn2r/2p5/2P5/2P2PPP/1R3R1K',
56:'1k6/pp1b4/8/P2pn2r/2p5/2P5/2P2PPP/1R3R1K',
57:'1k6/pp1b4/8/P2pn2r/2p5/2P4P/2P2PP1/1R3R1K',
58:'8/ppkb4/8/P2pn2r/2p5/2P4P/2P2PP1/1R3R1K',
59:'8/ppkb4/8/P2pn2r/2p5/2P4P/2P2PP1/1R3RK1',
60:'8/p1kb4/8/Pp1pn2r/2p5/2P4P/2P2PP1/1R3RK1',
61:'8/p1kb4/1P6/3pn2r/2p5/2P4P/2P2PP1/1R3RK1',
62:'8/2kb4/1p6/3pn2r/2p5/2P4P/2P2PP1/1R3RK1',
63:'8/2kb4/1p6/3pn2r/2p2P2/2P4P/2P3P1/1R3RK1',
64:'8/2kb1n2/1p6/3p3r/2p2P2/2P4P/2P3P1/1R3RK1',
65:'8/2kb1n2/1p6/3p3r/2p2P2/2P2R1P/2P3P1/1R4K1',
66:'8/2kb1n2/8/1p1p3r/2p2P2/2P2R1P/2P3P1/1R4K1',
67:'8/2kb1n2/8/1p1p3r/2p2PP1/2P2R1P/2P5/1R4K1',
68:'7r/2kb1n2/8/1p1p4/2p2PP1/2P2R1P/2P5/1R4K1',
69:'7r/2kb1n2/8/1p1p4/2p2PP1/2P2R1P/2P3K1/1R6',
70:'7r/2k2n2/2b5/1p1p4/2p2PP1/2P2R1P/2P3K1/1R6',
71:'7r/2k2n2/2b5/1p1p4/2p2PP1/2P2R1P/2P3K1/4R3',
72:'7r/2k5/2bn4/1p1p4/2p2PP1/2P2R1P/2P3K1/4R3',
73:'7r/2k1R3/2bn4/1p1p4/2p2PP1/2P2R1P/2P3K1/8',
74:'3k3r/4R3/2bn4/1p1p4/2p2PP1/2P2R1P/2P3K1/8',
75:'3k3r/R7/2bn4/1p1p4/2p2PP1/2P2R1P/2P3K1/8',
76:'3k3r/R7/2bn4/1p6/2pp1PP1/2P2R1P/2P3K1/8',
77:'3k3r/R7/2bn4/1p3P2/2pp2P1/2P2R1P/2P3K1/8',
78:'3k3r/R7/2bn4/1p3P2/2p3P1/2Pp1R1P/2P3K1/8',
79:'3k3r/R7/2bn4/1p3P2/2p3P1/2PP1R1P/6K1/8',
80:'3k3r/R7/2bn4/1p3P2/6P1/2Pp1R1P/6K1/8',
81:'3k3r/8/R1bn4/1p3P2/6P1/2Pp1R1P/6K1/8',
82:'3k3r/8/R1bn4/1p3P2/6P1/2P2R1P/3p2K1/8',
83:'3k3r/8/2bn4/1p3P2/6P1/2P2R1P/3p2K1/R7',
84:'3k3r/8/3n4/1p3P2/6P1/2P2b1P/3p2K1/R7',
85:'3k3r/8/3n4/1p3P2/6P1/2P2K1P/3p4/R7',
86:'3k4/8/3n4/1p3P2/6P1/2P2K1r/3p4/R7',
87:'3k4/8/3n4/1p3P2/5KP1/2P4r/3p4/R7',
88:'3k4/8/3n4/1p3P2/5KP1/2r5/3p4/R7',
89:'3k4/8/3n4/1p3P2/5KP1/2r5/3p4/3R4',
90:'3k4/8/8/1p3P2/2n2KP1/2r5/3p4/3R4',
},
comments:{
0:'Bobby Fischer - Harry Kord.',
1:'1.e4', 2:'1...e6 We believe Bobby’s opponent in the following game is the same player who defeated Paul Keres in the 1943 Estonian Championship.', 3:'2.d4', 4:'2...d5', 5:'3.Nc3', 6:'3...Bb4 “I may be forced to admit that the Winawer is sound. But I doubt it!  The defense is anti-positional and weakens the kingside.” - Fischer, My 60 Memorable Games. Keres played 4.a3 against Kord. ', 7:'4.e5', 8:'4...Ne7', 9:'5.a3', 10:'5...Bxc3+', 11:'6.bxc3', 12:'6...c5',
13:'7.a4', 14:'7...Qa5', 15:'8.Bd2', 16:'8...Nbc6', 17:'9.Nf3', 18:'9...c4!? Conventional wisdom holds that Black should hold off on this move and maintain the tension in the center, while developing with 9...Bd7. The text has had a bad reputation since the 1940s, but is not an easy nut to crack.', 19:'10.Ng5 The classical way of answering 9... c4, but 10.g3 is probably equally good.', 20:'10...h6', 21:'11.Nh3', 22:'11...Bd7 Black can try to cut across White’s plan of Nh3-f4-h5 with 11...Ng6, but after 12.Be2, intending 13.Bh5, White has the advantage.', 23:'12.Nf4',
24:'12...O-O-O', 25:'13.Be2 This move is natural, but 13.Nh5, attacking g7 and restraining ...f7-f6, is more thematic. Black might then try 13...Qc7, meeting 14.Nxg7 with 14...Nxe5. White should answer 13...Qc7 with 14.Be2 and a slight edge.', 26:'13...f6', 27:'14.exf6', 28:'14...gxf6', 29:'15.O-O', 30:'15...e5', 31:'16.Nh5', 32:'16...Rdf8', 33:'17.Kh1',
34:'17...Kb8', 35:'18.Rb1', 36:'18...Ka8', 37:'19.Qc1', 38:'19...Qc7', 39:'20.Bxh6', 40:'20...Rf7', 41:'21.dxe5', 42:'21...Rfh7', 43:'22.Bg7',
44:'22...Rxh5', 45:'23.Bxh5', 46:'23...Rxh5', 47:'24.Bxf6', 48:'24...Nxe5', 49:'25.Qf4', 50:'25...N7g6', 51:'26.Bxe5', 52:'26...Qxe5',
53:'27.Qxe5', 54:'27...Nxe5', 55:'28.a5', 56:'28...Kb8', 57:'29.h3', 58:'29...Kc7', 59:'30.Kg1', 60:'30...b5? This allows White to get rid of his weak a-pawn. Better was 30...Nc6 31.Ra1 d4 with a complicated struggle. White has three connected passed pawns on the kingside, but Black’s minor pieces are very active.', 61:'31.axb6+', 62:'31...axb6',
63:'32.f4', 64:'32...Nf7', 65:'33.Rf3', 66:'33...b5', 67:'34.g4', 68:'34...Rh8', 69:'35.Kg2? Asking for trouble on the diagonal. Bobby should have played 35.Rd1 Bc6 36.Re3.', 70:'35...Bc6', 71:'36.Re1', 72:'36...Nd6',
73:'37.Re7+? This check leaves both of White’s rooks under attack. Instead, Fischer had to play 37.Kh2.', 74:'37...Kd8', 75:'38.Ra7', 76:'38...d4', 77:'39.f5 The last chance to continue fighting was 39.cxd4.', 78:'39...d3', 79:'40.cxd3', 80:'40...cxd3', 81:'41.Ra6', 82:'41...d2',
83:'42.Ra1', 84:'42...Bxf3+', 85:'43.Kxf3', 86:'43...Rxh3+', 87:'44.Kf4', 88:'44...Rxc3', 89:'45.Rd1', 90:'45...Nc4',
}
},
{
  id:3,
  diagrams:{
0:'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR',
1:'rnbqkbnr/pppppppp/8/8/4P3/8/PPPP1PPP/RNBQKBNR',
2:'rnbqkbnr/pppp1ppp/8/4p3/4P3/8/PPPP1PPP/RNBQKBNR',
3:'rnbqkbnr/pppp1ppp/8/4p3/4PP2/8/PPPP2PP/RNBQKBNR',
4:'rnbqkbnr/pppp2pp/5p2/4p3/4PP2/8/PPPP2PP/RNBQKBNR',
5:'rnbqkbnr/pppp2pp/5p2/4P3/4P3/8/PPPP2PP/RNBQKBNR',
6:'r1bqkbnr/pppp2pp/2n2p2/4P3/4P3/8/PPPP2PP/RNBQKBNR',
7:'r1bqkbnr/pppp2pp/2n2p2/4P3/3PP3/8/PPP3PP/RNBQKBNR',
8:'r1bqk1nr/ppppb1pp/2n2p2/4P3/3PP3/8/PPP3PP/RNBQKBNR',
9:'r1bqk1nr/ppppb1pp/2n2P2/8/3PP3/8/PPP3PP/RNBQKBNR',
10:'r1bqk1nr/ppppb2p/2n2p2/8/3PP3/8/PPP3PP/RNBQKBNR',
11:'r1bqk1nr/ppppb2p/2n2p2/7Q/3PP3/8/PPP3PP/RNB1KBNR',
12:'r1bq1knr/ppppb2p/2n2p2/7Q/3PP3/8/PPP3PP/RNB1KBNR',
13:'r1bq1knr/ppppb2p/2n2p2/7Q/2BPP3/8/PPP3PP/RNB1K1NR',
14:'r1b1qknr/ppppb2p/2n2p2/7Q/2BPP3/8/PPP3PP/RNB1K1NR',
15:'r1b1qknr/ppppb2p/2n2p1B/7Q/2BPP3/8/PPP3PP/RN2K1NR',
},
comments:{
0:'Bobby Fischer - Jones.',
1:'1.e4', 2:'1...e5', 3:'2.f4', 4:'2...f6', 5:'3.fxe5', 6:'3...Nc6', 7:'4.d4', 8:'4...Be7', 9:'5.exf6', 10:'gxf6',
11:'6.Qh5+', 12:'6...Kf8', 13:'7.Bc4', 14:'7...Qe8', 15:'8.Bh6+',
}
  }
  ]
  }
  ];
